import ParameterErrors from '../errors/ParameterErrors';
import isNullOrUndefined from '../core/isNullOrUndefined';
const {throwNotProvided}=ParameterErrors;
export default class Option{
	constructor(props){
		const{text, value, className}=props;
		if(isNullOrUndefined(text))throwNotProvided('text');
		if(value===undefined)throwNotProvided('value');
		this._className = className;
		this._text = text;
		this._value = value;
		this._valueString = typeof(value)==='string'?value:JSON.stringify(value);
	}
	get value(){
		return this._value;
	}
	get valueString(){
		return this._valueString;
	}
	get className(){
		return this._className;
	}
	get text(){
		return this._text;
	}
}